import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { getEmployeesMeCall } from './api';

type sagaIteratorFunction = () => SagaIterator;

export const allSagas: sagaIteratorFunction[] = [getEmployeesMeCall.saga];

export function* profileSaga(): SagaIterator {
  yield all(allSagas.map((s: sagaIteratorFunction) => fork(s)));
}
